import React from 'react';
import { getImageUrl } from '../../utils/imageUtils';

const LoadingComponent = () => (
  <div className="flex justify-center w-full h-[calc(100vh-48px)] p-12">
    <img
      alt="Cargando la página..."
      src={getImageUrl(require('assets/images/loading.gif'))}
      className="max-h-48 select-none pointer-events-none"
      style={{
        imageRendering: 'smooth !important',
        WebkitFontSmoothing: 'auto !important',
        MozOsxFontSmoothing: 'auto !important'
      }}
    />
  </div>
);

export default LoadingComponent;
